import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserSocialSecurityForm } from "Bands/components";
import { editUserSocialSecurityForm, userSocialSecurityFormSelectorCreator } from "Bands/state";
import { IUserSocialSecurityFormPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { UserForm } from "shared/assets/icons";

const { userSocialSecurityForm: formCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserSocialSecurityFormModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const formIdSelector = useMemo(() => userSocialSecurityFormSelectorCreator(id), [id]);
  const form = useSelector(formIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserSocialSecurityFormPatchData) => {
    dispatch(editUserSocialSecurityForm({ id, data }));
  };

  const defaultValues = useMemo(() => {
    const files: { [key: string]: { id: string; originalURL: string } } = {};

    form?.files.forEach(({ id, source }, index) => {
      if (!source) return;

      files[`files.${index}`] = { id, originalURL: source };
    });

    // show original uploaded files as preview
    return {
      ...form,
      files,
    };
  }, [form]);

  return (
    <UserEntityModal
      defaultValues={defaultValues}
      title={formCopy.edit.title}
      icon={UserForm}
      action={USER_ACTIONS.editUserSocialSecurityForm}
      buttons={buttons}
      successMessage={formCopy.messages.edited}
      Component={UserSocialSecurityForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
